<template>
  <section class="about-media">
    <div class="osk-wrapper">
      <h2 class="section-title">
        {{ $t('components.home.old.aboutMedia.title') }}
      </h2>

      <div class="about-media__subtitle">
        {{ $t('components.home.old.aboutMedia.subtitle') }}
      </div>

      <div class="about-media__content">
        <a
          v-for="(card, index) in cards"
          :key="index"
          class="about-media__card"
          :href="card.href"
          target="_blank"
        >
          <div class="about-media__logo-block">
            <img
              class="about-media__logo"
              :class="card.alt"
              :src="card.imageSrc"
              :alt="card.alt"
            >
          </div>

          <div class="about-media__text">{{ card.text }}</div>
          <div class="about-media__date">{{ card.dateText }}</div>
        </a>
      </div>

      <div class="about-media__footer">
        <a
          class="about-media__link"
          href="/info/press"
        >
          {{ $t('components.home.old.aboutMedia.showAllArticles') }}
        </a>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
const { t } = useI18n();

const cards = [
  {
    href: 'https://www.cosmo.ru/fashion/how_to/vazhnyy-vopros-na-chto-obratit-vnimanie-pri-pokupke-b-u-veshchi/',
    imageSrc: '//static.oskelly.ru/images/icons/logo-cosmopolitan.png',
    alt: t('components.home.old.aboutMedia.card1.alt'),
    text: t('components.home.old.aboutMedia.card1.text'),
    dateText: t('components.home.old.aboutMedia.card1.dateText'),
  },
  {
    href: 'https://vc.ru/trade/66518-startap-dnya-rossiyskiy-marketpleys-poderzhannoy-brendovoy-odezhdy-oskelly',
    imageSrc: '//static.oskelly.ru/images/icons/vcru.png',
    alt: t('components.home.old.aboutMedia.card2.alt'),
    text: t('components.home.old.aboutMedia.card2.text'),
    dateText: t('components.home.old.aboutMedia.card2.dateText'),
  },
  {
    href: 'http://www.sncmedia.ru/fashion/lyuksovye-veshchi-kak-investitsii-vo-chto-vkladyvat/?fbclid=IwAR3h4L_e2LyY2A8rFuE0ARxZXNP_T-Y6q4F0H-k06gQjXEN00pJemlifO40',
    imageSrc: '//static.oskelly.ru/images/icons/logo_snc.svg',
    alt: t('components.home.old.aboutMedia.card3.alt'),
    text: t('components.home.old.aboutMedia.card3.text'),
    dateText: t('components.home.old.aboutMedia.card3.dateText'),
  },
  {
    href: 'https://kp.vedomosti.ru/deluxe/article/2019/03/28/797663-poddelki-i-modnie-doma-vred-i-polza',
    imageSrc: '//static.oskelly.ru/images/icons/Vedomosti_logo.png',
    alt: t('components.home.old.aboutMedia.card4.alt'),
    text: t('components.home.old.aboutMedia.card4.text'),
    dateText: t('components.home.old.aboutMedia.card4.dateText'),
  },
];
</script>

<style scoped lang="scss">
.about-media {
  background: #fafafa;
  padding: 52px 0 30px;

  @media screen and (min-width: 767px) {
    padding: 104px 0 79px;
  }

  .section-title {
    text-align: center;
  }

  &__subtitle {
    display: none;

    @media screen and (min-width: 767px) {
      display: block;
      text-align: center;
      max-width: 520px;
      margin: 16px auto 0;
      color: #828282;
      font-size: 14px;
      line-height: 22px;
    }
  }

  &__content {
    margin-top: 35px;

    @media screen and (min-width: 767px) {
      display: flex;
      justify-content: space-between;
      margin-left: -8px;
      margin-right: -8px;
      margin-top: 52px;
    }

    @media screen and (min-width: 767px) {
      margin-left: -12px;
      margin-right: -12px;
    }
  }

  &__card {
    padding: 20px 24px 12px 14px;
    display: block;
    box-shadow: 0 0 8px 0 rgb(0 0 0 / 3%);
    border-radius: 2px;
    background: #fff;

    & + & {
      margin-top: 12px;
    }

    @media screen and (min-width: 767px) {
      width: 33.333%;
      margin: 0 8px;
      transition: .3s;

      & + & {
        margin-top: 0;
      }

      &:last-child {
        display: none;
      }
    }

    @media screen and (min-width: 1024px) {
      width: 25%;
      margin: 0 12px;

      &:last-child {
        display: block;
      }

      &:hover {
        transform: translateY(-10px);
      }
    }
  }

  &__logo-block {
    height: 30px;
    margin-bottom: 24px;
  }

  &__logo {
    display: block;
    max-height: 100%;

    &.cosmopolitan {
      width: 115px;
    }

    &.vcru {
      width: 102px;
    }

    &.snc {
      width: 66px;
    }

    &.vedomosti {
      width: 135px;
    }
  }

  &__text {
    font-size: 13px;
    line-height: 20px;
    font-weight: 600;
    margin-bottom: 4px;
  }

  &__date {
    color: #828282;
    font-size: 13px;
  }

  &__footer {
    display: flex;
    justify-content: center;
  }

  &__link {
    display: block;
    height: 46px;
    color: #141414;
    text-align: center;
    line-height: 44px;
    transition: .3s;
    border: 1px solid #141414;
    border-radius: 2px;
    font-size: 14px;
    margin-top: 20px;
    width: 100%;

    &:hover {
      opacity: .5;
    }

    @media screen and (min-width: 767px) {
      display: inline-block;
      width: 294px;
      margin-top: 40px;
    }
  }
}
</style>
